module.exports = __webpack_public_path__ + "static/media/car-garage.dabda21b.svg";